import styled from 'styled-components';
import { Row as RowGrid, Col as ColGrid, Container } from 'react-grid-system';

export const Row = styled(RowGrid)`
  display: flex;
  width: 100%;
  margin-bottom: ${({ $marginBottom }) => $marginBottom || '25px'};
  margin: ${({ $margin }) => $margin};
  padding: ${({ $padding }) => $padding};
`;

export const Col = styled(ColGrid)`
  margin: ${({ $margin }) => $margin};
  padding: ${({ $padding }) => $padding};
  height: fit-content;
`;

export const GridContainer = styled(Container)`
  width: 100%;
`;
